import qs from 'qs';
import axios from 'axios';
import request from '@/utils/request';
import clientRequest from '@/utils/clientRequest';

const PATH = '/user';

const OAUTH_API_URL = process.env.VUE_APP_OAUTH_API;

export const getUserInfo = () => request({
  url: `${PATH}/info/me`,
  method: 'get',
});

export const login = (data: any) => {
  data.grant_type = 'password';
  return axios({
    method: 'post',
    url: `${OAUTH_API_URL}token`,
    data: qs.stringify(data),
    headers: {
      Authorization: 'Basic c2luZ2hhX29hdXRoOnNpbmdoYXNjcmVjdCFAIyQ=',
    },
  });
};

export const tokenCheck = (jwt: any) => {
  const token = {
    token: jwt,
  };
  return axios({
    method: 'post',
    url: `${OAUTH_API_URL}check_token`,
    data: qs.stringify(token),
  });
};

export const updateMyPassword = (data: any) => request({
  url: `${PATH}/mypage/password`,
  method: 'put',
  data,
});

export const updateBusiness = (data: any, orgPwd: string) => request({
  url: `${PATH}/update/business`,
  method: 'put',
  data: {
    ...data,
    originalPassword: orgPwd,
  },
});

export const findId = (params: any) => clientRequest({
  url: `${PATH}/find/id`,
  method: 'get',
  params,
});

export const findPassword = (params: any) => clientRequest({
  url: `${PATH}/find/password`,
  method: 'get',
  params,
});
